/* eslint-disable import/prefer-default-export */
import { remove } from 'lodash';

export const removeZeroYenItem = (allPayrolls, notDisplay0YenAllowances) => {
  if (!allPayrolls || !notDisplay0YenAllowances) {
    return allPayrolls;
  }
  return allPayrolls.map(payroll => {
    remove(
      payroll.employeePayAllowances,
      item => item.value === 0 && notDisplay0YenAllowances.includes(item.clientAllowanceId)
    );
    return payroll;
  });
};
